<div class="collapsible-section">
  <h3 (click)="toggle()" class="section-title">
    {{ title }}
    <svg class="chevron" [class.rotated]="!isOpen" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
      <path fill-rule="evenodd" d="M1.646 5.646a.5.5 0 0 1 .708 0L8 11.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
    </svg>
  </h3>
  <div [@expandCollapse]="isOpen ? 'open' : 'closed'" class="section-content">
    <ng-content></ng-content>
  </div>
</div>